import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WINDOW_TOKEN } from '../../components/shared/window.token';

interface FileTypes {
  isMedia: boolean;
  isMediaAndDoc: boolean;
}

@Component({
  selector: 'wk-duplicate-files',
  styleUrls: ['./notification.dialog.scss'],
  templateUrl: './notification.dialog.html',
  standalone: false,
})
export class NotificationDialogComponent implements OnInit {
  public multipleFiles: boolean;
  public dialogLoaded: boolean;
  public duplicates: any[];
  public showDelete: boolean;
  public associatedFiles: [];
  public fileTypes: FileTypes;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(WINDOW_TOKEN) public window: Window
  ) {}

  ngOnInit(): void {
    this.multipleFiles = this.data.multipleFiles;
    this.duplicates = this.data.duplicateFiles;
    this.associatedFiles = this.data.associatedFilesValues;
    this.fileTypes = this.data.fileTypes;
    this.dialogLoaded = true;
    this.showDelete = this.data.type === 'associated';
  }

  closeDialog() {
    this.dialogRef.close();
  }

  takeToPreview(id: string) {
    this.openPreview(this.getUrlPreview(id));
  }

  getUrlPreview(id: string) {
    const currentUrl = this.window.location.href;
    return `${currentUrl.split('#')[0]}#/dashboard/preview/${id}`;
  }

  openPreview(url: string) {
    this.window.open(url, '_blank');
  }
}
